export default __webpack_public_path__ + "static/media/codepicnic.868d37fa.svg";